import type { HTMLAttributes } from 'react';
import { cn } from '../../../lib/utils';
import { Button } from '../../ui/button';
import { CheckIcon } from '../../../icons/check';

export interface SuccessScreenProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: string;
  /** Um `<p>` por item; a linha em branco entre eles é o espaçamento. */
  paragraphs: string[];
  actionLabel: string;
  onAction: () => void;
  'data-testid'?: string;
}

/** Tela de conclusão de fluxo: ícone de confirmação, título, texto e uma ação. */
function SuccessScreen({
  title,
  paragraphs,
  actionLabel,
  onAction,
  className,
  'data-testid': testId,
  ...props
}: SuccessScreenProps) {
  return (
    <div
      data-slot="success-screen"
      data-testid={testId}
      className={cn('flex w-full flex-col items-center gap-6 text-center', className)}
      {...props}
    >
      <div className="flex size-16 items-center justify-center rounded-full bg-secondary">
        <CheckIcon className="size-6 text-secondary-foreground" aria-hidden />
      </div>
      <div className="flex max-w-md flex-col gap-4">
        <h1 className="text-2xl font-semibold leading-none tracking-tight text-foreground">
          {title}
        </h1>
        {paragraphs.map((text) => (
          <p key={text} className="text-sm leading-5 text-accent-foreground">
            {text}
          </p>
        ))}
      </div>
      <Button
        type="button"
        onClick={onAction}
        className="min-h-11"
        data-testid={testId ? `${testId}-action` : undefined}
      >
        {actionLabel}
      </Button>
    </div>
  );
}
SuccessScreen.displayName = 'SuccessScreen';

export { SuccessScreen };
